/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_B5_TInputs */

const en_mk_abt_b5_t = /** @type {(inputs: Mk_Abt_B5_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesian is not a translation layer`)
};

const id_mk_abt_b5_t = /** @type {(inputs: Mk_Abt_B5_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia bukan terjemahan`)
};

/**
* | output |
* | --- |
* | "Indonesian is not a translation layer" |
*
* @param {Mk_Abt_B5_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_b5_t = /** @type {((inputs?: Mk_Abt_B5_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_B5_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_b5_t(inputs)
	return en_mk_abt_b5_t(inputs)
});